// Companion/blocks/HelpDocBlock.tsx
import { ArticleBlockBody } from './bodies/ArticleBlockBody/ArticleBlockBody';
import { HelpDocBlockBody } from './bodies/HelpDocBlockBody/HelpDocBlockBody';
import type { ChatHelpDocBlockPayload } from '@/types/chatBlocks';

/**
 * A help doc served into the thread — the official answer to "how does the app
 * work".
 *
 * When `search_help_docs` already returned the body, the ported
 * `HelpDocBlockBody` renders it as-is. When the payload carries only a slug,
 * the ported `ArticleBlockBody` fetches the doc by slug and renders it with the
 * same expander an article gets, rather than showing nothing.
 */
const HelpDocBlock = ({ payload }: { payload: ChatHelpDocBlockPayload }) =>
  payload.content ? (
    <HelpDocBlockBody
      item={{ title: payload.title ?? '', content: payload.content }}
    />
  ) : (
    <ArticleBlockBody item={{ helpDocSlug: payload.slug }} />
  );

export default HelpDocBlock;
